import TopicHeader from "./TopicHeader/TopicHeader";
import PageTitle from "./PageTitle/PageTitle";
import HtmlContent from "./HtmlContent/HtmlContent";
import Image from "./Image/Image";
import ImageLink from "./ImageLink/ImageLink";
import Button from "./Button/Button";
import Attachments from "./Attachments/Attachments";
import HighlightBlock from "./HighlightBlock/HighlightBlock";
import HeaderBlock from "./HeaderBlock/HeaderBlock";

export default {
  "topic-header": TopicHeader,
  "page-title": PageTitle,
  "html-content": HtmlContent,
  "image": Image,
  "image-link": ImageLink,
  "button": Button,
  "attachments": Attachments,
  "highlight-block": HighlightBlock,
  "header-block": HeaderBlock,
};
